import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('PartGroup', () => {
  describe('Index', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_part_groups: [
            {id: 1, name: "カテゴリ1_名称", description: "カテゴリ1_詳細", display_web_name: "カテゴリ1_表示名", description_web: null, m_company_id: 1, common_kbn: 0, part_count: 1},
            {id: 2, name: "カテゴリ2_名称", description: "カテゴリ2_詳細", display_web_name: "カテゴリ2_表示名", description_web: null, m_company_id: 1, common_kbn: 0, part_count: 2},
            {id: 3, name: "カテゴリ3_名称", description: "カテゴリ3_詳細", display_web_name: "カテゴリ3_表示名", description_web: null, m_company_id: 1, common_kbn: 0, part_count: 3},
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      // タイトル
      expect(screen.getByRole("heading", {name: "先確認カテゴリ一覧"})).toBeInTheDocument();

      // 検索エリア
      expect(screen.getByRole("columnheader", {name: "カテゴリ名"})).toBeInTheDocument();

      // 注意書き文言
      // expect(screen.getByRole("heading", {name: "管理者以外使用しないでください。アンケートを表示するには店舗毎にアンケート表示設定をしてください。※ 新規追加・変更・コピー・削除を行うと、全店舗に反映されます。"})).toBeInTheDocument();

      // ボタン類
      expect(screen.getByText('カテゴリ登録')).toBeInTheDocument();

      // 表示エリア
      expect(screen.getByRole("row", {name: "カテゴリ名 説明 質問数"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "カテゴリ1_名称 カテゴリ1_詳細 1 編集 削除"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "カテゴリ2_名称 カテゴリ2_詳細 2 編集 削除"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "カテゴリ3_名称 カテゴリ3_詳細 3 編集 削除"})).toBeInTheDocument();
    });  
  }); 
});

